function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { getExpressionRanges, resolveCssVariablesInRecord } from '@deephaven/components';
import { GridTheme } from '@deephaven/grid';
import Log from '@deephaven/log';
import { ColorUtils } from '@deephaven/utils';
import IrisGridThemeRaw from "./IrisGridTheme.module.css";
var log = Log.module('IrisGridTheme');
/**
 * Derive default Iris grid theme from IrisGridThemeRaw. Note that CSS variables
 * contained in IrisGridThemeRaw are resolved to their actual values. This means
 * that the returned theme is statically defined based on the CSS variable values
 * at the time this function is called. They will not automatically update if the
 * CSS variables change.
 */
export function createDefaultIrisGridTheme() {
  var _IrisGridTheme$rowBa;
  var IrisGridTheme = resolveCssVariablesInRecord(IrisGridThemeRaw);
  // row-background-colors is a space-separated list of colors, so we need to
  // normalize each color expression in the list individually
  IrisGridTheme['row-background-colors'] = getExpressionRanges((_IrisGridTheme$rowBa = IrisGridTheme['row-background-colors']) !== null && _IrisGridTheme$rowBa !== void 0 ? _IrisGridTheme$rowBa : '').map(_ref => {
    var _ref2 = _slicedToArray(_ref, 2),
      start = _ref2[0],
      end = _ref2[1];
    return ColorUtils.normalizeCssColor(IrisGridTheme['row-background-colors'].substring(start, end + 1));
  }).join(' ');
  log.debug2('Iris grid theme:', IrisGridThemeRaw);
  log.debug2('Iris grid theme derived:', IrisGridTheme);
  return Object.freeze(_objectSpread(_objectSpread({}, GridTheme), {}, {
    backgroundColor: IrisGridTheme['grid-bg'],
    white: IrisGridTheme.white,
    black: IrisGridTheme.black,
    font: IrisGridTheme.font,
    filterBarFont: IrisGridTheme.font,
    headerBackgroundColor: IrisGridTheme['header-bg'],
    headerColor: IrisGridTheme['header-color'],
    headerSeparatorColor: IrisGridTheme['header-separator-color'],
    headerSeparatorHoverColor: IrisGridTheme['header-separator-hover-color'],
    headerHiddenSeparatorHoverColor: IrisGridTheme['header-hidden-separator-hover-color'],
    headerSortBarColor: IrisGridTheme['header-sort-bar-color'],
    headerReverseBarColor: IrisGridTheme['header-reverse-bar-color'],
    headerBarCasingColor: IrisGridTheme['header-bar-casing-color'],
    headerFont: IrisGridTheme['header-font'],
    rowBackgroundColors: IrisGridTheme['row-background-colors'],
    rowHoverBackgroundColor: IrisGridTheme['row-hover-bg'],
    selectionColor: IrisGridTheme['selection-color'],
    selectionOutlineColor: IrisGridTheme['selection-outline-color'],
    selectionOutlineCasingColor: IrisGridTheme['selection-outline-casing-color'],
    selectedRowHoverBackgroundColor: IrisGridTheme['selected-row-hover-bg'],
    scrollBarBackgroundColor: IrisGridTheme['scroll-bar-bg'],
    scrollBarHoverBackgroundColor: IrisGridTheme['scroll-bar-hover-bg'],
    scrollBarCasingColor: IrisGridTheme['scroll-bar-casing-color'],
    scrollBarCornerColor: IrisGridTheme['scroll-bar-corner-color'],
    scrollBarColor: IrisGridTheme['scroll-bar-color'],
    scrollBarHoverColor: IrisGridTheme['scroll-bar-hover-color'],
    scrollBarActiveColor: IrisGridTheme['scroll-bar-active-color'],
    scrollBarSelectionTickColor: IrisGridTheme['selected-row-hover-bg'],
    scrollBarActiveSelectionTickColor: IrisGridTheme['scroll-bar-active-selection-tick-color'],
    textColor: IrisGridTheme['text-color'],
    hyperlinkColor: IrisGridTheme['hyperlink-color'],
    positiveNumberColor: IrisGridTheme['positive-number-color'],
    negativeNumberColor: IrisGridTheme['negative-number-color'],
    zeroNumberColor: IrisGridTheme['zero-number-color'],
    dateColor: IrisGridTheme['date-color'],
    pendingTextColor: IrisGridTheme['pending-text-color'],
    errorTextColor: IrisGridTheme['error-text-color'],
    nullStringColor: IrisGridTheme['null-string-color'],
    filterBarActiveBackgroundColor: IrisGridTheme['filter-bar-active-bg'],
    filterBarExpandedBackgroundColor: IrisGridTheme['filter-bar-expanded-bg'],
    filterBarExpandedActiveBackgroundColor: IrisGridTheme['filter-bar-expanded-active-bg'],
    filterBarExpandedActiveCellBackgroundColor: IrisGridTheme['filter-bar-expanded-active-cell-bg'],
    filterBarSeparatorColor: IrisGridTheme['filter-bar-separator-color'],
    filterBarActiveColor: IrisGridTheme['filter-bar-active-color'],
    filterBarErrorColor: IrisGridTheme['filter-bar-error-color'],
    filterIconColor: IrisGridTheme['filter-icon-color'],
    scrimColor: IrisGridTheme['scrim-color'],
    contextMenuSortIconColor: IrisGridTheme['context-menu-sort-icon-color'],
    contextMenuReverseIconColor: IrisGridTheme['context-menu-reverse-icon-color'],
    allowRowResize: false,
    autoSelectRow: true,
    gridColumnColor: null,
    gridRowColor: null,
    groupedColumnDividerColor: IrisGridTheme['grouped-column-divider-color'],
    columnHoverBackgroundColor: null,
    headerHorizontalPadding: 12,
    scrollBarSize: 13,
    scrollBarHoverSize: 16,
    // system default scrollbar width is 17
    minScrollHandleSize: 24,
    rowHeight: parseInt(IrisGridTheme['row-height'], 10) || 19,
    // IrisGrid test breaks without the fallback value
    columnWidth: 100,
    rowHeaderWidth: 0,
    rowFooterWidth: 90,
    columnHeaderHeight: parseInt(IrisGridTheme['header-height'], 10) || 30,
    filterBarHeight: 30,
    // includes 1px casing at bottom
    filterBarCollapsedHeight: 5,
    // includes 1px casing at bottom
    sortHeaderBarHeight: 2,
    reverseHeaderBarHeight: 4,
    filterBarHorizontalPadding: 4,
    iconSize: 16,
    activeCellSelectionBorderWidth: parseInt(IrisGridTheme['active-cell-selection-border-width'], 10) || 2,
    shadowAlpha: parseFloat(IrisGridTheme['row-shadow-alpha']) || 0.15,
    // Amount of blur to apply to the bottom of the scrim while animating in
    scrimBlurSize: 25,
    minScrimTransitionTime: 150,
    maxScrimTransitionTime: 350,
    scrollSnapToRow: true,
    linkerColumnHoverBackgroundColor: IrisGridTheme['linker-column-hover-bg'],
    treeLineColor: IrisGridTheme['tree-line-color'],
    treeMarkerColor: IrisGridTheme['tree-marker-color'],
    treeMarkerHoverColor: IrisGridTheme['tree-marker-hover-color'],
    floatingGridColumnColor: null,
    floatingGridRowColor: IrisGridTheme['floating-grid-row-color'],
    floatingRowBackgroundColors: IrisGridTheme['floating-row-background-colors'],
    floatingDividerInnerColor: IrisGridTheme['floating-divider-inner-color'],
    floatingDividerOuterColor: IrisGridTheme['floating-divider-outer-color'],
    overflowButtonColor: IrisGridTheme['overflow-button-color'],
    overflowButtonHoverColor: IrisGridTheme['overflow-button-hover-color'],
    zeroLineColor: IrisGridTheme['zero-line-color'],
    positiveBarColor: IrisGridTheme['positive-bar-color'],
    negativeBarColor: IrisGridTheme['negative-bar-color'],
    markerBarColor: IrisGridTheme['marker-bar-color'],
    density: {
      compact: {
        cellHorizontalPadding: 5,
        // Same as regular set in GridTheme
        headerHorizontalPadding: 10,
        minColumnWidth: 10,
        rowHeight: 16,
        font: '11px Fira Sans, sans-serif',
        iconSize: 14,
        columnHeaderHeight: 26
      },
      spacious: {
        cellHorizontalPadding: 7,
        headerHorizontalPadding: 15,
        rowHeight: 28
      }
    }
  }));
}
//# sourceMappingURL=IrisGridTheme.js.map